export default __webpack_public_path__ + "static/fluid-908c44f1e96ddc309a3be944d110d6fe.mp4";